import React from "react";

export const Timeout = () => {
    return (
        <></>
    );
}